<template>
  <div class="business_block">
    <div class="left">
      <h3 class="large_blue_label">発注業務について。</h3>
      <p>本サービスでは、基本的に初見の相手と契約することとなりますので、短期・単発の業務を専門に取り扱います。よって、右記の注意点にご留意ください。</p>
    </div>
    <div class="right">
      <div>
        <div class="left">
          <img class='base_image' src='@/assets/image/pages/information/usages/service_2_1.png'>
        </div>
        <div class="right">
          <p class="marker-underline_label">業務は1～8時間で完了する業務に限ります。</p>
          <p>クライアントに作業見込み時間を設定頂きます。</p>
          <p>ただし、マッチング後にクライアントとオペレーターが合意したうえで、作業量の追加や納期の延長をすることはできます。</p>
        </div>
      </div>
      <div>
        <div class="left">
          <img class='base_image' src='@/assets/image/pages/information/usages/service_2_2.png'>
        </div>
        <div class="right">
          <p class="marker-underline_label">契約は1回限りになります。</p>
          <p>CADオペレーターは請け負った仕事に後々拘束されることはありません。</p>
          <p>同一のCADオペレーターへの継続発注は想定していません。</p>
        </div>
      </div>
      <div>
        <div class="left">
          <img class='base_image' src='@/assets/image/pages/information/usages/service_2_3.png'>
        </div>
        <div class="right">
          <p class="marker-underline_label">どこをどう変えるのか、指示は明確に。</p>
          <p>仕事を受注するCADオペレーターは、その図面を始めて見るので、丁寧な説明を心がけてください。</p>
          <p>また、スキルやセンスで出来栄えが変わるような依頼は想定していません。</p>
          <p>「こんな感じで・・・」は禁物です。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BusinessBlock",
  }
</script>

<style lang="scss" scoped>
  .business_block {
    @include double_columns(30%, 50%);

    .large_blue_label {
      margin-bottom: 2rem;
    }

    > .right > div {
      @include double_columns(20%, 70%);
      margin: 2rem auto;
    }

    @media screen and (max-width: 767px) {
      > .right > div > .left > .base_image {
        margin: 2rem auto;
        max-height: 20rem;
      }
    }
  }
</style>